import { Logo as WiseLogo, LogoType } from '@transferwise/components';
import React from 'react';
import Types from 'prop-types';
import { Locale, LocaleValues, SupportedHomeLocales } from '../../common/l10n';
import FooterBottomItem from './FooterBottomItem';
var FooterBottom = function FooterBottom(_ref) {
  var items = _ref.items,
    inverse = _ref.inverse,
    locale = _ref.locale;
  var logoLink = "/".concat(Object.values(SupportedHomeLocales).includes(locale) ? locale : '');
  return /*#__PURE__*/React.createElement("div", {
    className: "row m-b-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 text-xs-center text-md-left footer-title"
  }, /*#__PURE__*/React.createElement("a", {
    className: "hidden-xs hidden-sm",
    href: logoLink,
    "data-testid": "footer-logo"
  }, /*#__PURE__*/React.createElement(WiseLogo, {
    inverse: inverse,
    type: LogoType.WISE
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 footer-bottom-group"
  }, items.map(function (item) {
    if (!item) {
      return null;
    }
    var link = item.link,
      translationKey = item.translationKey;
    return /*#__PURE__*/React.createElement("div", {
      className: "footer-bottom-item  text-xs-center text-md-left footer-title",
      key: translationKey || link
    }, /*#__PURE__*/React.createElement(FooterBottomItem, {
      link: link,
      translationKey: translationKey,
      inverse: inverse
    }));
  })));
};
FooterBottom.defaultProps = {
  inverse: false,
  locale: Locale.GB
};
export default FooterBottom;